import React, { useEffect } from "react";

export default function useOnClickOutside(
  ref: React.MutableRefObject<HTMLDivElement | null>,
  handleOutsideClick: (event: MouseEvent) => void,
  isClickOutsideEnabled = true
): void {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      // we need to optionally disable this util in the context of a form so that it behaves like the other form inputs and doesn't invalidate until touched
      if (!isClickOutsideEnabled) return;

      if (
        !ref.current ||
        ref.current.contains?.(event.target as HTMLDivElement)
      ) {
        return;
      }

      handleOutsideClick(event);
    };

    document.addEventListener("click", onClick);

    return () => document.removeEventListener("click", onClick);
  }, [ref, handleOutsideClick]);
}
